import {makeActionType} from '@/utils/reduxHelpers';

const REDUCER_NAME = 'ORDER_PROXY';

export const GET_UI_MANAGED_CONFIGURATION = makeActionType(REDUCER_NAME, 'GET_UI_MANAGED_CONFIGURATION');
